import React from 'react';
import PropTypes from 'prop-types';

class StatusFormatter extends React.Component {
  static propTypes = {
    value: PropTypes.string.isRequired
  };

  render() {
    const currentStatus = this.props.value;
    var backgroundColor = 'orange';
    if (currentStatus === 'DONE') {
      backgroundColor = 'green';
    } else if (currentStatus === 'ERROR') {
      backgroundColor = 'red';
    } else {
      backgroundColor = 'orange';
    }
    return (
      <div style={{backgroundColor: backgroundColor}}>
        <div aria-valuenow="60" aria-valuemin="0" aria-valuemax="100">
          {currentStatus}
        </div>
      </div>
    );
  }
}

export default StatusFormatter;


// WEBPACK FOOTER //
// ./src/components/Status.jsx